import { AuthAccessTokenDetails } from '../models/tokens.interfaces';

export const isTokenValid = (token: AuthAccessTokenDetails): boolean => {
  if (token && token.access_token && token.token_issued_time) {
    return isTokenAlive(token);
  }
  return false;
};

export const isTokenAlive = (token: AuthAccessTokenDetails): boolean => {
  const currentTimeMillis = Date.now();
  const expires_in = token.expires_in ? token.expires_in : 0;
  const expiryTimeMillis = token.token_issued_time + expires_in * 1000;
  const remainingLifeSpanMillis = expiryTimeMillis - currentTimeMillis;
  return remainingLifeSpanMillis >= 5 * 60 * 1000;
};
